import Link, { type LinkProps } from 'next/link';

import { clc, type BaseProps } from '@/legacy/components/base/utils';

import styles from '@/legacy/components/btn/Buttons.module.scss';

const tag = {
	button: 'button',
	link: Link,
};

type Option = 'button' | 'link';

type TagPropsType<T extends Option> = T extends 'button' ? BaseProps['button'] : LinkProps;

type Props<T extends Option> = {
	buttonType: T;
	color: 'purple' | 'pink' | 'gray' | 'soildGray' | 'subPurple' | 'Alternative';
} & BaseProps['button'];

const LButton = <T extends Option>({
	buttonType,
	color,
	className,
	children,
	...props
}: Props<T> & TagPropsType<T>) => {
	if (buttonType === 'button') {
		return (
			<button className={clc(styles.L, styles[color], className)} {...(props as TagPropsType<'button'>)}>
				{children}
			</button>
		);
	}
	if (buttonType === 'link') {
		return (
			<Link className={clc(styles.L, styles[color], className)} {...(props as unknown as TagPropsType<'link'>)}>
				{children}
			</Link>
		);
	}
};

export default LButton;
